export default __webpack_public_path__ + "static/media/AboutMe.ccce73a1.png";